<template>
  <div class="Reset">
    <div class="Reset_main">
      <div class="Reset_title">重置密码</div>
      <div class="formBox">
        <div style="display: flex;align-items: center;">
          <div class="inputBox">
            <!-- <el-input v-model="Email" placeholder="请输入您的电子邮箱，用于重置密码"></el-input> -->
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <el-form-item label="电子邮箱" prop="Email">
                <el-input v-model="ruleForm.Email" placeholder="请输入您的电子邮箱，用于重置密码" clearable></el-input>
              </el-form-item>
              <el-form-item style="margin-top:48px">
                <el-button type="primary" size="medium" @click="submitForm('ruleForm')" style="width:100%;height:60px">马上发送</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      ruleForm:{
        Email:"",
      },
      rules:{
        Email: [
          { required: true, message: '请输入电子邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
      }
    }
  },
  methods:{
    ResetPassworld(){
      let url = "/userController/front/retrievePassword"
      this.$axios.get(url,{
        params:{
          email:this.ruleForm.Email
        }
      }).then(res=>{
        console.log(res)
        this.$message({
            showClose: true,
            message: res.data.message,
            type: 'success'
          });
      })
    },
    submitForm(formName) {
      console.log(this.ruleForm.resource)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ResetPassworld()
        } else {
          return false;
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.Reset{
  width: 100%;
  height: 678px;
  margin-top: 18px;
  .Reset_main{
    width: 1200px;
    margin: 0 auto;
    .Reset_title{
      width: 100%;
      padding: 30px 0;
      font-size: 30px;
      font-family: NotoSansHans-Regular, NotoSansHans;
      font-weight: 400;
      color: #333333;
      border-bottom: 1px solid #E6E8ED;
      text-align: center;
    }
    .formBox{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 30px 0;
      .inputBox{
        width: 480px;
        margin-left: 20px;
        .Reset_name{
          font-size: 14px;
          font-family: NotoSansHans-Regular, NotoSansHans;
          font-weight: 400;
          color: #333333;
        }
      }
      .ResetBtn{
        width: 380px;
        height: 60px;
        background: #1373CF;
        border-radius: 4px;
        font-size: 18px;
        font-family: NotoSansHans-Medium, NotoSansHans;
        font-weight: 500;
        color: #FFFFFF;
        text-align: center;
        line-height: 60px;
        margin-top: 48px;
        cursor: pointer;
      }
    }
  }
}
</style>